function DirectMessage(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.977 13.187a.432.432 0 00-.043-.593.473.473 0 00-.618-.018l-8.268 6.76-4.366-1.622c-.19-.07-.355-.19-.475-.348a.988.988 0 01-.074-1.1c.099-.172.246-.312.425-.404l18.125-9.76a.923.923 0 01.918.041.87.87 0 01.312.346.83.83 0 01.083.451l-1.59 15.93c-.016.163-.071.32-.162.46-.09.14-.213.256-.359.342a1.13 1.13 0 01-.98.078l-5.313-1.977-3.335 3.004a.894.894 0 01-.934.153.854.854 0 01-.378-.308.804.804 0 01-.138-.456v-2.36l7.17-8.619z"
        fill="#A8ADB2"
      />
    </svg>
  )
}

export default DirectMessage
